import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  loadSingleStaff,
  updateUser,
} from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";

const ProfileEditPopup = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const singleUser = useSelector((state) => state.users.user);
  const user = singleUser?.EmployeesDetail ? singleUser.EmployeesDetail[0] : null;
  const { id } = useParams();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const masterData = useSelector((state) => state.masters.masters);

  useEffect(() => {
    dispatch(getAllMaster());
  }, []);

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        EmployeeId: user.EmployeeId,
        FirstName: user.FirstName || "",
        MiddleName: user.MiddleName || "",
        LastName: user.LastName || "",
        FatherName: user.FatherName || "",
        EmailId: user.EmailId || "",
        BloodGroupTypeId: user.BloodGroupTypeId || null,
        BirthDate: user.BirthDate ? dayjs(user.BirthDate) : null,
        BirthAnniversary: user.BirthAnniversary ? dayjs(user.BirthAnniversary) : null,
        MaritalStatus: user.MaritalStatus ? "Married" : "Single",
        MarriageAnniversary: user.MarriageAnniversary ? dayjs(user.MarriageAnniversary) : null,
        GenderTypeId: user.GenderTypeId || null,
        PanNumber: user.PanNumber || "",
        AadharNumber: user.AadharNumber || "",
        TitleTypeId: user.TitleTypeId || null,
        PhoneNumber: user.PhoneNumber || "",
        AlternateNumber: user.AlternateNumber || "",
        DataStatus: user.DataStatus || 1,
      });
    }
  }, [user, form]);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const onFinish = async (values) => {
    try {
      setLoader(true);

      const updatedValues = {
        ...values,
        BirthDate: values.BirthDate ? values.BirthDate.format("YYYY-MM-DD") : null,
        BirthAnniversary: values.BirthAnniversary ? values.BirthAnniversary.format("YYYY-MM-DD") : null,
        MarriageAnniversary: values.MarriageAnniversary ? values.MarriageAnniversary.format("YYYY-MM-DD") : null,
        MaritalStatus: values.MaritalStatus === "Married" ? true : false,
        EmployeeId: values.EmployeeId,
        DataStatus: values.DataStatus || 1,
      };

      const resp = await dispatch(
        updateUser(updatedValues)
      );

      if (resp.payload.message === "success") {
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
      }
    } catch (error) {
      // console.error(error.message);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        width="50%"
        title="Update User Information"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={form.getFieldsValue()}
        >
           <Form.Item name="EmployeeId" hidden>
                      <Input />
                    </Form.Item>
          
                    <Form.Item name="DataStatus" hidden>
                      <Input />
                    </Form.Item>
          <Form.Item
            label="Title"
            name="TitleTypeId"
            rules={[{ required: true, message: "Please select Title!" }]}
          >
            <Select 
              placeholder="Select Title"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.TitleTypeMaster?.map((title) => (
                <Select.Option key={title.TitleTypeId} value={title.TitleTypeId}>
                  {title.TitleTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="First Name"
            name="FirstName"
            rules={[{ required: true, message: "Please input First Name!" }]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item
            label="Middle Name"
            name="MiddleName"
          >
            <Input placeholder="Middle Name" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="LastName"
            // rules={[{ required: true, message: "Please input Last Name!" }]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
          <Form.Item
            label="Father Name"
            name="FatherName"
            // rules={[{ required: true, message: "Please input Father Name!" }]}
          >
            <Input placeholder="Father Name" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="EmailId"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please input a valid email!",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="PhoneNumber"
            rules={[{ required: true, message: "Please input Phone Number!" }]}
          >
            <Input placeholder="Phone Number" />
          </Form.Item>
          <Form.Item
            label="Alternate Number"
            name="AlternateNumber"
          >
            <Input placeholder="Alternate Number" />
          </Form.Item>
          <Form.Item
            label="Blood Group"
            name="BloodGroupTypeId"
           // rules={[{ required: true, message: "Please select Blood Group!" }]}
          >
            <Select 
              placeholder="Select Blood Group"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.BloodGroupTypeMaster?.map((group) => (
                <Select.Option key={group.BloodGroupTypeId} value={group.BloodGroupTypeId}>
                  {group.BloodGroupTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Birth Date"
            name="BirthDate"
          //  rules={[{ required: true, message: "Please select Birth Date!" }]}
          >
            <DatePicker format="DD-MMM-YYYY" />
          </Form.Item>
          <Form.Item
            label="Birth Anniversary"
            name="BirthAnniversary"
          >
            <DatePicker format="DD-MMM-YYYY" />
          </Form.Item>
          <Form.Item
            label="Marital Status"
            name="MaritalStatus"
            // rules={[{ required: true, message: "Please select Marital Status!" }]}
          >
            <Select 
              placeholder="Select Status"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.MaritalStatusTypeMaster?.map((status) => (
                <Select.Option key={status.MaritalStatusTypeId} value={status.MaritalStatusTypeName}>
                  {status.MaritalStatusTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Marriage Anniversary"
            name="MarriageAnniversary"
          >
            <DatePicker format="DD-MMM-YYYY" />
          </Form.Item>
          <Form.Item
            label="Gender"
            name="GenderTypeId"
          //  rules={[{ required: true, message: "Please select Gender!" }]}
          >
            <Select 
              placeholder="Select Gender"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.GenderTypeMaster?.map((gender) => (
                <Select.Option key={gender.GenderTypeId} value={gender.GenderTypeId}>
                  {gender.GenderTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="PAN"
            name="PanNumber"
          //  rules={[{ required: true, message: "Please input PAN!" }]}
          >
            <Input placeholder="PAN" />
          </Form.Item>
          <Form.Item
            label="Aadhar"
            name="AadharNumber"
          //  rules={[{ required: true, message: "Please input Aadhar Number!" }]}
          >
            <Input placeholder="Aadhar Number" />
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loader} block>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ProfileEditPopup;